<div class="main">
    <div class="main__inner">
        <img class="main__logo" src="../../../assets/images/logo.png" alt="">
        <app-main-tabs *ngIf="!hideTabs()"></app-main-tabs>
        <router-outlet></router-outlet>
    </div>
    <app-footer *ngIf="!hideTabs()"></app-footer>
</div>

